document.addEventListener('DOMContentLoaded', function() {
  function repositionSidebarMobile() {
    // Only run on mobile viewports
    if (window.innerWidth <= 767) {
      const sidebar = document.querySelector('.article__info');
      if (!sidebar) return;
      
      // Check if sidebar is already moved
      if (sidebar.hasAttribute('data-mobile-repositioned')) return;
      
      // Find the main content wrapper
      const mainContent = document.querySelector('#MainContent') || document.querySelector('main') || document.body;
      
      // Find all sections in the page
      const allSections = mainContent.querySelectorAll('section');
      
      if (allSections.length > 0) {
        // Get the last section
        const lastSection = allSections[allSections.length - 1];
        
        // Create a new section wrapper for the sidebar
        const sidebarSection = document.createElement('section');
        sidebarSection.className = 'article-sidebar-mobile-section';
        sidebarSection.innerHTML = `
          <div class="container" style="max-width: 1400px; margin: 0 auto; padding: 0 20px;">
            <div class="article">
              <div class="article__inner-mobile">
              </div>
            </div>
          </div>
        `;
        
        // Clone the sidebar to preserve event listeners
        const sidebarClone = sidebar.cloneNode(true);
        sidebarClone.setAttribute('data-mobile-repositioned', 'true');
        
        // Add the cloned sidebar to the new section
        sidebarSection.querySelector('.article__inner-mobile').appendChild(sidebarClone);
        
        // Insert the new section after the last section
        lastSection.insertAdjacentElement('afterend', sidebarSection);
        
        // Hide the original sidebar
        sidebar.style.display = 'none';
        sidebar.setAttribute('data-original-sidebar', 'true');
        
        // Copy any form functionality for newsletter
        const originalForm = sidebar.querySelector('form');
        const clonedForm = sidebarClone.querySelector('form');
        
        if (originalForm && clonedForm) {
          clonedForm.addEventListener('submit', function(e) {
            // Trigger submit on the original form
            const event = new Event('submit', { bubbles: true, cancelable: true });
            originalForm.dispatchEvent(event);
            
            // Copy the behavior
            if (e.defaultPrevented) {
              e.preventDefault();
            }
          });
        }
      }
    } else {
      // On desktop, restore original sidebar if it was hidden
      const originalSidebar = document.querySelector('.article__info[data-original-sidebar]');
      const mobileSidebar = document.querySelector('.article-sidebar-mobile-section');
      
      if (originalSidebar && mobileSidebar) {
        originalSidebar.style.display = '';
        originalSidebar.removeAttribute('data-original-sidebar');
        mobileSidebar.remove();
      }
    }
  }
  
  // Run on load
  repositionSidebarMobile();
  
  // Run on resize with debouncing
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(repositionSidebarMobile, 250);
  });
});